import React from 'react';
import { Link } from 'react-router-dom';
import FacebookLogin from 'react-facebook-login';

import bdErrorTracking from '@bd-uikit-web/js-helpers/bdErrorTracking';
import { Form, Input } from '@bd-uikit-web/React/Form';
import SimpleModal from '@bd-uikit-web/React/SimpleModal';

import bdReq from '@bd-uikit-web/js-helpers/bdReq';
import bdAuth from '@bd-uikit-web/js-helpers/bdAuth';
import rootDispatcher from '@bd-uikit-web/js-helpers/rootDispatcher';
import autobind from '@bd-uikit-web/js-helpers/autobind';

// show reset password if the pass key is set
import ResetPassword from './ResetPassword.jsx';

export default class Login extends React.Component {
  constructor(props) {
    super();
    this.props = props;
    this.registerUrl = bdReq.getURLParameter('register-url') || '/register';
    this.state = {
      submitting: false
    };
    this.search = this.search.bind(this);
  }

  componentWillMount() {
    const tokenLogin = bdAuth.getTokenLogin();

    if (tokenLogin.paramsValid) {
      this.setState({ submitting: true });
      tokenLogin.authenticate().then(() => {
        if (bdAuth.isAuthenticated()) {
          this.redirect();
        }
      });
      return;
    }

    if (bdAuth.isAuthenticated()) {
      this.redirect();
      return;
    }
  }

  @autobind
  search(field) {
    const search = this.props.location.search
      .slice(1)
      .split('&')
      .map((p) => p.split('='))
      .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
    return search[field];
  }

  @autobind
  redirect() {
    const redirectUrl = this.search('redirect-url');

    if (redirectUrl) {
      if (!redirectUrl.includes('.')) {
        this.props.history.push(redirectUrl);
        return;
      }
      location.href = `${redirectUrl}`;
      return;
    }

    // Redirect user after successfull login to the overview page
    rootDispatcher.dispatch('LOGIN');
    this.props.history.push('/');
  }

  @autobind
  onFacebookLogin({ accessToken }) {
    this.setState({ submitting: true });
    bdAuth
      .authenticate(null, null, accessToken)
      .then(({ success, body }) => {
        if (!success) {
          this.setState({
            submitting: false
          });

          rootDispatcher.dispatch('NB:OPEN', {
            type: 'error',
            msg: body.message
          });
          return;
        }

        this.redirect();
      })
      .catch((err) => {
        /* Logging the error is consistent with bd-reseller-portal */
        console.log('FACEBOOK ERROR', err);
        this.setState({
          submitting: false
        });

        bdErrorTracking.captureException(err);
        rootDispatcher.dispatch('NB:OPEN', {
          type: 'error',
          msg: `Whoops! Looks like something went wrong on our side.
                Our support team has been notified. Try again later.`
        });
      });
  }

  @autobind
  onFormSubmit({ email, password }) {
    this.setState({ submitting: true });
    bdAuth
      .authenticate(email, password)
      .then(({ success, body }) => {
        if (!success) {
          this.setState({
            submitting: false
          });

          rootDispatcher.dispatch('NB:OPEN', {
            type: 'error',
            msg: body.message
          });
          return;
        }

        this.redirect();
      })
      .catch((err) => {
        /* Logging the error is consistent with bd-reseller-portal */
        console.log('LOGIN ERROR', err);
        this.setState({
          submitting: false
        });

        bdErrorTracking.captureException(err);
        rootDispatcher.dispatch('NB:OPEN', {
          type: 'error',
          msg: `Whoops! Looks like something went wrong on our side.
                Our support team has been notified. Try again later.`
        });
      });
  }

  render() {
    const passToken = this.search('pass-token');
    if (passToken) {
      this.props.location.search = this.props.location.search
        .replace(`?pass-token=${passToken}`)
        .replace(`&pass-token=${passToken}`);

      return <ResetPassword {...this.props} type="set" token={passToken} />;
    }
    return (
      <div className="m-bg-image">
        <div class="m-bg-wrapper">
          <img className="m-bg-logo" src="/assets/img/blackdove-logo.png" alt="Blackdove Logo" />
          <h1> The most efficient way to enjoy digital art. </h1>
          <div className="m-bg-container">
            <Form onSubmit={this.onFormSubmit}>
              <div className="m-bg-input-wrapper">
                <Input className="m-bg-input-style" type="email" name="email" placeholder="Email" invalidMsg="Please enter a valid email" required />
                <Input className="m-bg-input-style" type="password" name="password" placeholder="Password" invalidMsg="Please enter a password" required/>
              </div>
              <div className="m-bg-button-wrapper">
                <button className="m-bg-login-button" type="submit" disabled={this.state.submitting}>
                  Login
                </button>
                <span className="m-bg-or">OR</span>
                <FacebookLogin
                  appId="189038304919308"
                  scope="public_profile,email"
                  fields="id,name,birthday,email,first_name,last_name,location"
                  callback={this.onFacebookLogin}
                  cssClass="btn btn--facebook btn--text-lower"
                  render={(renderProps) => (
                    <button className="btn btn--facebook btn--text-lower metro" onClick={renderProps.onClick}>
                      Login with Facebook
                    </button>
                  )}
                />
              </div>
            </Form>
          </div>
          <div className="form__group form__group--first-link">
            <a className="a--clean" href={`${this.registerUrl}${location.search}`}>
              <span className="m-bg-span">
                Don't have an account?{' '}
                <strong>
                  <u>Sign Up</u>
                </strong>
              </span>
            </a>
          </div>
          <div className="m-bg-forgot-wrapper">
            <Link className="a--clean" to={`/forgot-password${location.search}`}>
              <span className="m-bg-span">
                <u>Forgot password</u>
              </span>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}
